import {
  DisplayColumn,
  ErrorMessage,
} from "../../../util/spreadsheet-data-utils";
import { ComponentRequirementList } from "../../project-plan/ProjectPlanPageState";

export type InputComponentRequirementDialogState = {
  isShow: boolean;
  saved: {
    reqType?: string;
    tstUseTypeCd?: string;
    componentRequirementList?: ComponentRequirementList[];
  };
  edited: {
    reqType?: string;
    tstUseTypeCd?: string;
    componentRequirementList?: ComponentRequirementList[];
  };
  codes: {
    tstUseFlg?: Option[];
    dipByRegionList?: Option[];
    reqType: Option[];
  };
  fieldPath: FieldPath;
  displayColumn: DisplayColumn[];
  pjtId: string;
  updateDateTime: string;
  status: {
    invalidList: string[];
    invalidRecordList: string[];
    isSaved: boolean;
  };
  spreadsheet: {
    selectRowIdx?: number;
    tmplateRow: SpreadsheetRecordData;
  };
};

export type Option = {
  label: string;
  value: string;
};

export type FieldPath = {
  tstUseTypeCd: string;
  reqType: string;
};

export type CellItem = {
  rowIdx: number;
  col: string;
};

export type SpreadsheetState = {
  results: SpreadsheetRecordData[];
  codes?: {
    dipByRegionList: Option[];
  };
};

export type SpreadsheetRecordData = {
  isAddRow: boolean;
  updateFlag?: boolean;
  delFlg: boolean;
  cpntReqId: string;
  dipByRgn: string;
  cpntId: string;
  cpntReqDesc: string;
  errorColumnList: string[];
  errorMessage: string;
  messageList: ErrorMessage[];
};

export type PageNewState =
  | InputComponentRequirementDialogState
  | ((
      prevState: InputComponentRequirementDialogState,
    ) => InputComponentRequirementDialogState);
